import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import {
    QuestionnaireStatus,
    QuestionnaireStatusMap
} from "pages/CourseDetail/Question/service";

interface StatusProps {
    status: QuestionnaireStatus;
}

export default function Status({ status }: StatusProps) {
    return (
        <span className={classNames(style.root, style[`state${status}`])}>
            {QuestionnaireStatusMap[status]}
        </span>
    );
}
